var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"auto"}},[_c('h6',{staticClass:"d-inline"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-col',[_c('b-breadcrumb',_vm._l((_vm.items),function(item,index){return _c('b-breadcrumb-item',{key:index,attrs:{"text":item.general ? item.general.title : item.title,"href":item.url,"target":"_blank"}})}))],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02468be5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Components/PageLinkList.vue
// module id = 1230
// module chunks = 0